<template>
  <div class="form-group" key="valueCash">
    <label for="text">{{ label }}</label>
    <input
        v-model.lazy="model"
        v-money="integer"
        class="form-control mb-1"
        @input="$emit('input', $event.target.value)"
        type="text"/>
    <HandleErrors v-model="errors" />
  </div>
</template>

<script>
import {VMoney} from 'v-money';
import HandleErrors from "./HandleErrors.vue";

export default {
  components: {HandleErrors},
  directives: {
    money: VMoney,
  },
  props: {
    errors: Array,
    name: String,
    label: String,
    value: {
      type: [String, undefined],
    }
  },

  data() {
    return {
      integer: {
        decimal: '',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false,
      },
    }
  },

  watch: {
    value() {
      this.model = this.value
    }
  },

  computed: {
    model: {
      set(value_cash) {
        const name = this.name.toUpperCase()
        this.$store.commit(`poster/SET_${name}`, value_cash);
      },
      get() {
        const name = this.name.toLowerCase()
        return this.$store.getters['poster/field'](name);
      },
    }
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/carrefour/inputs/InputNumber.vue